export const MODULE = 'RM';
export const RO_ITEM = 'RMOI';
export const RO_PICKLIST = 'RMOP';
